var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146.95 80.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .hiring-header {\n        fill: #3c5572;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hiring_header_1",
    "data-name": "Hiring Header 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hiring-header",
    d: "M0,0h146.95v43.27c0,20.55-16.69,37.24-37.24,37.24H37.24C16.69,80.5,0,63.82,0,43.27V0H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiring);
export default __webpack_public_path__ + "static/media/Hiring.5ab0e0417040831226fdcbfae0a47134.svg";
export { ForwardRef as ReactComponent };